(function ($) {
    var halo = {
        initReviewSlider: function () {
            var testimonialContainer = $('[data-review-slider]');
            
            if (testimonialContainer.length > 0) {
                var testimonials = testimonialContainer.find('.halo-item');
                var totalTestimonials = testimonials.length;
                var testimonialsPerView = 4; // Show 4 at a time
                
                // Calculate animation duration based on number of testimonials
                var animationDuration = totalTestimonials * 2; // 2 seconds per testimonial
                
                // Add CSS with keyframe animation
                var style = $('<style>')
                    .prop('type', 'text/css')
                    .html(`
                        .testimonial-scroll-container {
                            overflow: hidden !important;
                            position: relative !important;
                            width: 100% !important;
                        }
                        .testimonial-scroll-wrapper {
                            display: flex !important;
                            animation: testimonialScroll ${animationDuration}s linear infinite !important;
                            width: ${totalTestimonials * 25}% !important;
                            margin: 0 !important;
                            padding: 0 !important;
                        }
                        .testimonial-scroll-wrapper .halo-item {
                            flex: 0 0 25% !important;
                            max-width: 25% !important;
                            padding: 0 10px !important;
                            box-sizing: border-box !important;
                            margin: 0 !important;
                            float: none !important;
                            display: block !important;
                        }
                        .testimonial-scroll-wrapper .halo-item .halo-row {
                            margin: 0 !important;
                        }
                        @keyframes testimonialScroll {
                            0% {
                                transform: translateX(0%);
                            }
                            100% {
                                transform: translateX(-${(totalTestimonials - testimonialsPerView) * 25}%);
                            }
                        }
                        .testimonial-scroll-container:hover .testimonial-scroll-wrapper {
                            animation-play-state: paused !important;
                        }
                    `);
                $('head').append(style);
                
                // Apply the new classes
                testimonialContainer.addClass('testimonial-scroll-container');
                testimonials.wrapAll('<div class="testimonial-scroll-wrapper"></div>');
            }
        }
    }
    
    // Initialize when document is ready
    $(document).ready(function() {
        halo.initReviewSlider();
    });
    
    // Also try to initialize after a delay
    setTimeout(function() {
        halo.initReviewSlider();
    }, 1000);
    
})(jQuery);